import { render, staticRenderFns } from "./GYOrder.vue?vue&type=template&id=6bcfd591&scoped=true&"
import script from "./GYOrder.vue?vue&type=script&lang=js&"
export * from "./GYOrder.vue?vue&type=script&lang=js&"
import style0 from "./GYOrder.vue?vue&type=style&index=0&id=6bcfd591&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcfd591",
  null
  
)

export default component.exports